import Vue from 'vue'
import { Api } from '@/core/api.js'
const api = new Api()

const state = {
    tickets: {},
    chatLoaded: false
}

const getters = {
    getList: (state, getters, rootState) => {
        return state.tickets
    },
    getById: (state, getters, rootState) => id => {
        return state.tickets[id]
    },
    getThreads: (state, getters, rootState) => id => {
        const ticket = state.tickets[id]
        return typeof ticket.threads !== 'undefined' ? ticket.threads : {}
    },
    getChatLoaded: (state, getters, rootState) => {
        return state.chatLoaded
    }
}

const actions = {
    loadList(context, params) {
        return api.login('ticket/list', { location_id: params.location_id }).then(response => {
            return response.status ? context.commit('setList', response.data) : false
        })
    },
    getThreads(context, params) {
        return api.login(`ticket/${params.id}/threads`, {}).then(response => {
            return response.status ? context.commit('setTicketThreads', { ticketId: params.id, data: response.data }) : false
        })
    },
    addTicket(context, params) {
        return api.login('ticket/add', { location_id: params.location_id, employee_id: params.employee_id, tool: params.tool, description: params.description, email: params.email, data: typeof params.data !== 'undefined' ? JSON.stringify(params.data) : '', language: params.language }).then(() => {
            return true
        })
    },
    addMessage(context, params) {
        return api.login(`ticket/${params.id}/thread/addmessage`, { message: params.message, employee_id: params.employee_id }).then(response => {
            return response.status ? context.commit('setTicketThread', { ticketId: params.id, data: response.data }) : false
        })
    }
}

const mutations = {
    setList(state, data) {
        state.tickets = data
    },

    setChatLoaded(state, data) {
        state.chatLoaded = data
    },

    setTicket(state, data) {
        const tickets = { ...state.tickets }
        tickets[data.id] = data
        Vue.set(state, 'tickets', tickets)
    },

    setTicketThreads(state, data) {
        const tickets = { ...state.tickets }
        tickets[data.ticketId].threads = data.data
        Vue.set(state, 'tickets', tickets)
    },

    setTicketThread(state, data) {
        const tickets = { ...state.tickets }
        if (typeof tickets[data.ticketId].threads === 'undefined') {
            tickets[data.ticketId].threads = {}
        }
        tickets[data.ticketId].threads[data.data.id] = data.data
        Vue.set(state, 'tickets', tickets)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
